import React from 'react';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import { ExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { ExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types/src/application.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

const VERSION_RELATED_WORK_EXPERIENCE_NAME = 'viewVersionRelatedWork';

type VersionRelatedWorkExperienceStartProps = {
	experienceId: string;
};

export const VersionRelatedWorkExperienceStart = ({
	experienceId,
}: VersionRelatedWorkExperienceStartProps) => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId={experienceId}
			experience={VERSION_RELATED_WORK_EXPERIENCE_NAME}
			analyticsSource="versionDetails"
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};

export const useViewVersionRelatedWorkExperienceFail = (): ReturnType<typeof useExperienceFail> =>
	useExperienceFail({
		experience: VERSION_RELATED_WORK_EXPERIENCE_NAME,
	});

export const VersionRelatedWorkExperienceSuccessTracker = () => (
	<ExperienceSuccess experience={VERSION_RELATED_WORK_EXPERIENCE_NAME} />
);
